<mat-card>
  <mat-card-title>
    <mat-icon class="material-icons-outlined">arrow_forward</mat-icon>
    Encuestas Asignadas a Coordinadores
  </mat-card-title>
  <mat-divider></mat-divider>

  <div *ngIf="isCoordinadorCadem" class="mt-4">
    <div class="row mt-4">
      <!-- <div class="col-lg-6 col-sm-12">
        <mat-card-title> 
          <mat-icon class="material-icons-outlined">person</mat-icon>
          {{ nombreEncuestador }}
        </mat-card-title>
      </div> -->
      <div class="col-lg-6 col-sm-12">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Coordinadores</mat-label>
          <input type="text" placeholder="Nombre Coordinador" aria-label="Coordinadores" matInput
            [formControl]="myControl" [matAutocomplete]="auto" oninput="this.value = this.value.toUpperCase()" (keyup.enter)="getEncuestasEncuestador('enter', {})">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"
              (click)="getEncuestasEncuestador('click', option)">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>
  <mat-card-content style="margin-top: 20px;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="Numero">
        <th mat-header-cell *matHeaderCellDef>FOLIO</th>
        <td mat-cell *matCellDef="let element" width="5%" align="center"> {{element.id_origen}} </td>
      </ng-container>

      <ng-container matColumnDef="ID">
        <th mat-header-cell *matHeaderCellDef>DIRECCIÓN</th>
        <td mat-cell *matCellDef="let element" align="center"> {{element.direccion}} </td>
      </ng-container>

      <ng-container matColumnDef="Fecha">
        <th mat-header-cell *matHeaderCellDef>FECHA ENCUESTA</th>
        <td mat-cell *matCellDef="let element" width="15%" align="center"> {{element.fecha_encuesta_origen}} </td>
      </ng-container>

      <ng-container matColumnDef="FechaAsignacion">
        <th mat-header-cell *matHeaderCellDef>FECHA ASIGNACIÓN</th>
        <td mat-cell *matCellDef="let element" width="15%" align="center"> {{element.fecha_asignacion}} </td>
      </ng-container>

      <ng-container matColumnDef="Dias-Restantes">
        <th mat-header-cell *matHeaderCellDef>DÍAS RESTANTES</th>
        <td mat-cell *matCellDef="let element" width="15%" align="center">
          <h6><span [class]="getColorDias(element.color_dias)">{{element.dias_restantes}}</span></h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="Estado">
        <th mat-header-cell *matHeaderCellDef>ESTADO</th>
        <td mat-cell *matCellDef="let element" width="15%" align="center" [class]="getColor(element.color_estado)">
          <b>{{element.estado}}</b>
        </td>
      </ng-container>

      <ng-container matColumnDef="Detalle">
        <th mat-header-cell *matHeaderCellDef> DETALLE </th>
        <td mat-cell *matCellDef="let element" align="center">
          <button mat-mini-fab color="primary" aria-label="Example icon button with a menu icon"
            (click)="detailsCall(element)">
            <mat-icon>search</mat-icon>
          </button>
        </td>
      </ng-container> 

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow align="center">
        <td class="mat-cell" colspan="10">
          <div *ngIf="isTblLoading; else elseLoading" class="mt-4 mb-4">
            <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
            </mat-progress-spinner>
          </div>
          <ng-template #elseLoading>{{noData}}</ng-template>
        </td>
      </tr>
    </table>
    <mat-paginator #paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>
  </mat-card-content>
</mat-card>